import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home-banner-image.png";
import Navbar from "./Navbar";
import DownloadAppStore from "../Assets/download-app-store.png";
import GetItOn from "../Assets/get-it-on.png";
import { APP_STORE_URL, PLAY_STORE_URL } from "../storeLinks";

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Money manager,
          </h1>
          <h1 className="primary-heading">
            Expense tracker &
          </h1>
          <h1 className="primary-heading">
            Budget planner
          </h1>
          <p className="primary-text">
            Soldi is a free money manager app. Keep track of your expenses and plan your budgets all in one place.
          </p>
          <div className="about-buttons-container">
            <a 
              href={APP_STORE_URL} 
              className="store-button"
              rel="noopener noreferrer"
            >
              <img src={DownloadAppStore} alt="Download on the App Store" />
            </a>
            <a 
              href={PLAY_STORE_URL} 
              className="store-button"
              rel="noopener noreferrer"
            >
              <img src={GetItOn} alt="Get it on Google Play" />
            </a>
          </div>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Home;